<template>
    <div class="shared-error text-small text-emphasis">
        <slot></slot>
    </div>
</template>

<script>
export default {};
</script>
